import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';

@Injectable()
export class UserTypeGuard implements CanActivate {
  constructor(public router: Router, public userService: UserService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userType: Array<string> =
      typeof next.data['userType'] === 'string' ? [next.data['userType']] : next.data['userType'];
    let allowed = false;
    if (this.userService.userData !== null) {
      if (this.userService.isAdmin()) { allowed = true; }

      if (userType.includes('adv') && !allowed) {
        allowed =
          !this.userService.isPublisher() &&
          !this.userService.isCedatoPublisher() &&
          userType.includes(this.userService.userData.userType);
      }

      if (userType.includes('publisher') && !allowed) {
        allowed = this.userService.isPublisher() && userType.includes(this.userService.userData.userType);
      }

      if (userType.includes('cedatopub') && !allowed) {
        allowed = this.userService.isCedatoPublisher() && userType.includes(this.userService.userData.userType);
      }

      if (!allowed) { this.router.navigate([this.userService.getDefaultRoute()]); }

      return allowed;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
